import { useState } from "react";
import { X } from "lucide-react";

export default function DiscountBanner() {
  const [open, setOpen] = useState(() => localStorage.getItem("mb_banner_closed") !== "1");
  if (!open) return null;

  return (
    <div
      data-testid="discount-banner"
      className="relative bg-[#E5A8A0] text-white text-center text-xs sm:text-sm py-1.5 sm:py-2.5 pl-3 pr-10 sm:px-10 font-display"
    >
      <span className="opacity-95">
        <span className="hidden sm:inline">Crea il tuo profilo e ricevi il tuo </span><span className="sm:hidden">Il tuo </span><strong>sconto personale del 15%</strong><span className="sm:hidden"> per ogni mamma iscritta</span><span className="hidden sm:inline">, applicato in automatico al checkout</span>
      </span>
      <button
        onClick={() => { localStorage.setItem("mb_banner_closed", "1"); setOpen(false); }}
        data-testid="discount-banner-close"
        className="absolute right-1 top-1/2 -translate-y-1/2 w-9 h-9 inline-flex items-center justify-center opacity-80 hover:opacity-100"
        aria-label="Chiudi"
      >
        <X size={16} />
      </button>
    </div>
  );
}
